export default function isEmbedded() {
  const getRouteBaseName = useRouteBaseName();
  return getRouteBaseName() === "embed-id-pagenumber";
}
